var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"timeline_konva__container"},[_c('v-stage',{ref:"stage",attrs:{"config":{ width: _vm.width, height: 60 }}},[_c('v-layer',{ref:"layer-history"},_vm._l((_vm.colors),function(color,index){return _c('v-group',{key:index},[_c('v-rect',{attrs:{"config":{
            x: _vm.getX(color.fromTs),
            y: 0,
            width: _vm.getWidthColorUrl(color),
            height: 60,
            fill: color.color
          }}})],1)}),1),_c('v-layer',{ref:"layer-archive"},_vm._l((_vm.timelines),function(timeline,index){return _c('v-group',{key:index},[_c('v-rect',{attrs:{"config":{
            x: _vm.getX(timeline.start),
            y: 0,
            width: _vm.getWidth(timeline.duration),
            height: 60,
            fill: "#1B5E20"
          }}})],1)}),1),_c('v-layer',{ref:"layer-motions"},_vm._l((_vm.motions),function(motion,index){return _c('v-group',{key:index},[_c('v-rect',{attrs:{"config":{
            x: _vm.getX(motion.start),
            y: 0,
            width: _vm.getWidth(motion.duration),
            height: 60,
            fill: "#FFA000",
          }}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }